import React, { useEffect, useState } from "react";
import api from "../../../api";
import {
  Users,
  UserPlus,
  UserMinus,
  UserCheck,
  Calendar,
  TrendingUp,
  TrendingDown,
  Minus,
  BarChart3,
  PieChartIcon,
  ChevronUp,
  ChevronDown,
  Target,
  Clock,
  CalendarDays,
  DollarSign,
  Percent,
  Activity,
  Search,
} from "lucide-react";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import "./WaqarStats.css";

export const WaqarStats = () => {
  const [loader, setLoader] = useState(false);
  const [activeLoader, setActiveLoader] = useState(false);
  const [data, setData] = useState({});
  const [genderPie, setGenderPie] = useState([]);
  const [activeSubscriptions, setActiveSubscriptions] = useState(0);

  const today = new Date().toISOString().split("T")[0];

  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [chartData, setChartData] = useState({
    signupData: [0, 0, 0, 0, 0, 0, 0],
    labels: ["Jan 7", "Jan 8", "Jan 9", "Jan 10", "Jan 11", "Jan 12", "Jan 13"],
    genderDistribution: { male: 0, female: 0, other: 0, total: 0 },
  });

  const getUsers = async (from, to) => {
    try {
      setLoader(true);
      const response = await api.getWaqarStats(from, to);
      // console.log("API Response:", response);
      setData(response);

      // Generate chart data based on response
      // generateChartData(response);
      // Generate chart data based on response
      if (response?.recentUser) {
        generateChartData(
          response.recentUser,
          response?.genderStats,
          response?.signupChart,
        );
      }

      setLoader(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
    }
  };
  const getActiveSubscription = async () => {
    try {
      setActiveLoader(true);
      const response = await api.getWaqarActiveSubs();
      // console.log("API Response:", response);
      if (response?.success) {
        setActiveSubscriptions(response?.activeSubcription);
      }

      setActiveLoader(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setActiveLoader(false);
    }
  };

  // const generateChartData = (response) => {
  //   let male = 0, female = 0, other = 0;

  //   // Handle gender stats
  //   if (response?.genderStats && Array.isArray(response.genderStats)) {
  //     response.genderStats.forEach((g) => {
  //       if (g._id === "male") male = g.count || 0;
  //       else if (g._id === "female") female = g.count || 0;
  //       else other += g.count || 0;
  //     });
  //   }

  //   const totalGender = male + female + other || 1;
  //   const genderDistribution = {
  //     male: Math.round((male / totalGender) * 100),
  //     female: Math.round((female / totalGender) * 100),
  //     other: Math.round((other / totalGender) * 100),
  //     total: totalGender,
  //   };

  //   // Use provided signup chart data or create default
  //   let signupData = [];
  //   let labels = [];

  //   if (response?.signupChart?.data && response?.signupChart?.labels) {
  //     signupData = response.signupChart.data;
  //     labels = response.signupChart.labels;
  //   } else {
  //     // Create default data for 7 days
  //     const today = new Date();
  //     labels = Array.from({ length: 7 }, (_, i) => {
  //       const date = new Date();
  //       date.setDate(today.getDate() - (6 - i));
  //       return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  //     });
  //     signupData = Array(7).fill(0);
  //   }

  //   setChartData({
  //     signupData,
  //     labels,
  //     genderDistribution,
  //   });
  // };

  const generateChartData = (users, genderStats, signupChart) => {
    // Generate user growth data (last 7 days)

    // Generate random signup data for demo

    let male = 0,
      female = 0,
      other = 0;

    genderStats.forEach((g) => {
      if (g._id === "male") male = g.count;
      else if (g._id === "female") female = g.count;
      else other += g.count;
    });

    const totalGender = male + female + other || 1;

    const genderDistribution = {
      male: Math.round((male / totalGender) * 100),
      female: Math.round((female / totalGender) * 100),
      other: Math.round((other / totalGender) * 100),
      total: totalGender,
    };
    const genderPieData = [
      { name: "Male", value: genderDistribution.male },
      { name: "Female", value: genderDistribution.female },
      { name: "Other", value: genderDistribution.other },
    ];
    setGenderPie(genderPieData);

    setChartData({
      signupData: signupChart?.data,
      labels: signupChart?.labels,
      genderDistribution,
    });
  };

  const getBarHeight = (value) => {
    const MAX_BAR_HEIGHT = 160;
    const maxValue = Math.max(...chartData.signupData, 1);
    return `${(value / maxValue) * MAX_BAR_HEIGHT}px`;
  };

  useEffect(() => {
    getUsers(fromDate, toDate);
    getActiveSubscription();
  }, []);

  // Calculate pie chart angles
  // const malePercentage = chartData.genderDistribution.male || 0;
  // const femalePercentage = chartData.genderDistribution.female || 0;
  // const otherPercentage = chartData.genderDistribution.other || 0;

  // const maleAngle = (malePercentage / 100) * 360;
  // const femaleAngle = (femalePercentage / 100) * 360;
  // const otherAngle = (otherPercentage / 100) * 360;

  const formatNumberUnit = (value) => {
    if (!value && value !== 0) return "0";

    const absValue = Math.abs(value);

    if (absValue >= 1e9) {
      return (value / 1e9).toFixed(1).replace(/\.0$/, "") + "B";
    }
    if (absValue >= 1e6) {
      return (value / 1e6).toFixed(1).replace(/\.0$/, "") + "M";
    }
    if (absValue >= 1e3) {
      return (value / 1e3).toFixed(1).replace(/\.0$/, "") + "k";
    }
    return value.toString();
  };

  const handleSearch = () => {
    getUsers(fromDate, toDate);
  };
  const handleReaset = () => {
    getUsers(today, today);
    setFromDate(today);
    setToDate(today);
  };

  return (
    <>
      <div className="waqar-dashboard">
        {/* Stats Grid - MOVED TO TOP */}
        <div className="waqar-stats-grid">
          {/* Query Section */}
          <div className="waqar-stats-section">
            <h2 className="waqar-section-title jc-sb">
              <div>
                <Clock size={20} /> Get Data By Date Range
              </div>
              <div className="dateRange d-flex ai-center">
                <div className="formGroup mb-2 me-2">
                  <label>From</label>
                  <input
                    type="date"
                    name="from"
                    value={fromDate}
                    className="form-control"
                    onChange={(e) => setFromDate(e.target.value)}
                  />
                </div>
                <div className="formGroup mb-2">
                  <label>To</label>
                  <input
                    type="date"
                    name="to"
                    value={toDate}
                    className="form-control"
                    onChange={(e) => setToDate(e.target.value)}
                  />
                </div>
                <button className="themeBtn mx-2" onClick={handleSearch}>
                  <Search size={23} />
                </button>
                <button className="themeBtn" onClick={handleReaset}>
                  Reset
                </button>
              </div>
            </h2>
          </div>

          {/* Today Section */}
          <div className="waqar-section-grid">
            <AnalyticsBox
              icon={<UserPlus size={22} />}
              title="Signup"
              amount={data?.signupsInRange || 0}
              trend="today"
              color="teal"
              isLoading={loader}
            />
            <AnalyticsBox
              icon={<Users size={22} />}
              title="Paid Members"
              amount={data?.paidMembersInRange || 0}
              trend="total"
              color="blue"
              isLoading={loader}
            />

            <AnalyticsBox
              icon={<UserMinus size={22} />}
              title="Un-Subscribed Members"
              amount={data?.unsubscribedInRange || 0}
              trend="down"
              color="red"
              isLoading={loader}
            />
          </div>
          <div className="waqar-section-grid">
            <AnalyticsBox
              icon={<UserPlus size={22} />}
              title="Total Users"
              amount={data?.userCount || 0}
              trend="total"
              color="teal-deep"
              isLoading={loader}
            />
            <AnalyticsBox
              icon={<Users size={22} />}
              title="Total Active subscriptions"
              amount={activeSubscriptions || 0}
              trend="total"
              color="blue-deep"
              isLoading={activeLoader}
            />
          </div>

          {/* <div className="waqar-stats-section">
            <h2 className="waqar-section-title">
              <Clock size={20} />
              Today
            </h2>
            <div className="waqar-section-grid">
              <AnalyticsBox
                icon={<UserPlus size={22} />}
                title="Signup Today"
                amount={data?.signupsToday || 0}
                trend="today"
                color="purple"
              />
              <AnalyticsBox
                icon={<Users size={22} />}
                title="Total Paid Members"
                amount={data?.totalPaidMembers || 0}
                trend="total"
                color="blue"
              />
              <AnalyticsBox
                icon={<UserCheck size={22} />}
                title="Paid in 24h"
                amount={data?.paidMembersIn24h || 0}
                trend="up"
                color="green"
              />
              <AnalyticsBox
                icon={<UserMinus size={22} />}
                title="Un-Subscribed in 24h"
                amount={data?.unsubscribedIn24h || 0}
                trend="down"
                color="red"
              />
            </div>
          </div> */}

          {/* 30 Days & Current Month Section */}
          {/* <div className="waqar-stats-section">
            <h2 className="waqar-section-title">
              <CalendarDays size={20} />
              Total (Last 30 Days)
            </h2>
            <div className="waqar-section-grid">
              <AnalyticsBox
                icon={<Target size={22} />}
                title="Signups (30 Days)"
                amount={data?.signupsIn30Days || 0}
                trend="up"
                color="orange"
              />
              <AnalyticsBox
                icon={<DollarSign size={22} />}
                title="Paid (30 Days)"
                amount={data?.paidMembersIn30Days || 0}
                trend="up"
                color="teal"
              />
              <AnalyticsBox
                icon={<UserMinus size={22} />}
                title="Un-Subscribed (30 Days)"
                amount={data?.unsubscribedIn30Days || 0}
                trend="down"
                color="pink"
              />
              <AnalyticsBox
                icon={<Calendar size={22} />}
                title="Signups This Month"
                amount={data?.signupsThisMonth || 0}
                trend="month"
                color="indigo"
              />
            </div>
          </div> */}

          {/* Monthly Comparison Section */}
          {/* <div className="waqar-stats-section">
            <h2 className="waqar-section-title">
              <Activity size={20} />
              Monthly Comparison
            </h2>
            <div className="waqar-section-grid">
              <AnalyticsBox
                icon={<Calendar size={22} />}
                title={`Paid in ${data?.previousMonthName || "Dec"}`}
                amount={data?.paidMembersPreviousMonth || 0}
                trend="neutral"
                color="gray"
              />
              <AnalyticsBox
                icon={<Calendar size={22} />}
                title={`Un-Subscribed in ${data?.previousMonthName || "Dec"}`}
                amount={data?.unsubscribedPreviousMonth || 0}
                trend="neutral"
                color="slate"
              />
              <AnalyticsBox
                icon={<Calendar size={22} />}
                title={`Paid in ${data?.currentMonthName || "Jan"}`}
                amount={data?.paidMembersThisMonth || 0}
                trend="up"
                color="cyan"
              />
              <AnalyticsBox
                icon={<Calendar size={22} />}
                title={`Un-Subscribed in ${data?.currentMonthName || "Jan"}`}
                amount={data?.unsubscribedThisMonth || 0}
                trend="down"
                color="rose"
              />
            </div>
          </div> */}

          {/* Trends Section */}
          {/* <div className="waqar-stats-section">
            <h2 className="waqar-section-title">
              <TrendingUp size={20} />
              Trends & Percentages
            </h2>
            <div className="waqar-section-grid">
              <AnalyticsBox
                icon={<Percent size={22} />}
                title="Paid vs Previous Month"
                amount={`${data?.paidChangePercent || 0}`}
                side={
                  data?.paidChangePercent > 0
                    ? "up"
                    : data?.paidChangePercent == 0
                      ? "neutral"
                      : "down"
                }
                isPercent={true}
                color={
                  data?.paidChangePercent > 0
                    ? "emerald"
                    : data?.paidChangePercent < 0
                      ? "red"
                      : "yellow"
                }
              />
              <AnalyticsBox
                icon={<Percent size={22} />}
                title="Unsub vs Previous Month"
                amount={`${data?.unsubChangePercent || 0}`}
                side={
                  data?.unsubChangePercent > 0
                    ? "up"
                    : data?.unsubChangePercent == 0
                      ? "neutral"
                      : "down"
                }
                isPercent={true}
                color={
                  data?.unsubChangePercent > 0
                    ? "red"
                    : data?.unsubChangePercent < 0
                      ? "emerald"
                      : "yellow"
                }
              />
            </div>
          </div> */}
        </div>

        {/* Charts Section - MOVED TO BOTTOM  */}
        <div className="waqar-charts-section">
          {/* Signups Chart */}
          <div className="waqar-chart-card">
            <div className="waqar-chart-header">
              <div className="waqar-chart-title">
                <BarChart3 size={20} />
                <h3>User Signups (Last 7 Days)</h3>
              </div>
              <div className="waqar-chart-period">
                <span className="waqar-period-active">7D</span>
              </div>
            </div>
            <div className="waqar-chart-body">
              <div className="waqar-bar-chart">
                {chartData.signupData.map((value, index) => (
                  <div key={index} className="waqar-bar-chart-item">
                    <div className="waqar-bar-chart-label">
                      {chartData.labels[index]}
                    </div>
                    <div className="waqar-bar-chart-bar-container">
                      <div
                        className="waqar-bar-chart-bar"
                        style={{ height: getBarHeight(value) }}
                        title={`${value} users`}
                      >
                        <span className="waqar-bar-value">{value}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Gender Distribution */}
          <div className="waqar-chart-card">
            <div className="waqar-chart-header">
              <div className="waqar-chart-title">
                <PieChartIcon size={20} />
                <h3>Gender Distribution</h3>
              </div>
            </div>
            <div className="waqar-chart-body">
              <div className="gender-chart-container">
                <div className="gender-legend">
                  <div className="legend-item">
                    <div className="legend-color legend-male"></div>
                    <span className="legend-text">
                      Male: {chartData?.genderDistribution?.male || 0}%
                    </span>
                  </div>
                  <div className="legend-item">
                    <div className="legend-color legend-female"></div>
                    <span className="legend-text">
                      Female: {chartData?.genderDistribution?.female || 0}%
                    </span>
                  </div>
                  <div className="legend-item">
                    <div className="legend-color legend-other"></div>
                    <span className="legend-text">
                      Other: {chartData?.genderDistribution?.other || 0}%
                    </span>
                  </div>
                </div>
                <div className="pie-chart">
                  {/* <div className="pie-chart-circle">
                      <div
                        className="pie-chart-slice male"
                        style={{
                          "--percentage": `${
                            chartData?.genderDistribution?.male || 0
                          }%`,
                        }}
                      ></div>
                      <div
                        className="pie-chart-slice female"
                        style={{
                          "--percentage": `${
                            chartData?.genderDistribution?.female || 0
                          }%`,
                        }}
                      ></div>
                      <div
                        className="pie-chart-slice other"
                        style={{
                          "--percentage": `${
                            chartData?.genderDistribution?.other || 0
                          }%`,
                        }}
                      ></div>
                    </div> */}
                  <PieGenderChart genderPieData={genderPie} />
                  <div className="pie-chart-center">
                    <div className="total-users">
                      {formatNumberUnit(chartData?.genderDistribution?.total) ||
                        0}
                    </div>
                    <div className="total-label">Total</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

function AnalyticsBox({
  icon,
  title,
  amount,
  trend,
  side,
  isPercent = false,
  color = "blue",
  isLoading,
}) {
  const getTrendConfig = () => {
    if (side) {
      switch (side) {
        case "up":
          return { icon: <ChevronUp size={16} />, text: "+" };
        case "down":
          return { icon: <ChevronDown size={16} />, text: "-" };
        default:
          return { icon: <Minus size={16} />, text: "" };
      }
    }

    switch (trend) {
      case "up":
        return { icon: <ChevronUp size={16} />, text: "+" };
      case "down":
        return { icon: <ChevronDown size={16} />, text: "-" };
      case "today":
        return { icon: <Clock size={16} />, text: "Today" };
      case "total":
        return { icon: <Users size={16} />, text: "Total" };
      case "month":
        return { icon: <Calendar size={16} />, text: "Month" };
      default:
        return { icon: <Minus size={16} />, text: "" };
    }
  };

  const trendConfig = getTrendConfig();

  return (
    <div className={`waqar-stat-box waqar-color-${color}`}>
      <div className="waqar-stat-header">
        <div className="waqar-stat-icon-container">{icon}</div>
        <div className="waqar-stat-title">{title}</div>
      </div>
      <div className="waqar-stat-content">
        <div className="waqar-stat-amount">
          {isLoading ? (
            <span className="waqar-stat-spinner" aria-hidden="true"></span>
          ) : (
            amount
          )}
          {isPercent && "%"}
        </div>
        <div className="waqar-stat-trend">
          {trendConfig.icon}
          <span>{trendConfig.text}</span>
        </div>
      </div>
    </div>
  );
}

const PieGenderChart = ({ genderPieData }) => {
  const COLORS = ["#0284c7", "#f97362", "#14b8a6"]; // male, female, other
  return (
    <ResponsiveContainer width="100%" height={200}>
      <PieChart>
        <Pie
          data={genderPieData}
          dataKey="value"
          nameKey="name"
          cx="50%"
          cy="50%"
          innerRadius={30}
          outerRadius={90}
          paddingAngle={3}
        >
          {genderPieData.map((_, index) => (
            <Cell key={index} fill={COLORS[index]} />
          ))}
        </Pie>

        <Tooltip formatter={(value) => `${value}%`} />
      </PieChart>
    </ResponsiveContainer>
  );
};
